import { Grid, Typography, useMediaQuery } from "@mui/material"
import { CoachingGoodToKnow } from "../subpages/CoachingGoodToKnow"
import { CoachingIntro } from "../subpages/CoachingIntro"
import { GZ } from "../subpages/GZ"
import { theme } from "../Theme"

export const CoachingDesktop: React.FC = () => {
    const biggerThanSm = useMediaQuery(theme.breakpoints.up('sm'));

   return (<>
            <div className="slide">
              <div className="fp-bg2 fp-auto-height-responsive">    
                <Grid container display={'flex'} alignItems={'center'} textAlign={'center'} spacing={4} marginLeft={'10%'} marginRight={'10%'}>
                  <Grid item xs={12}>
                    <Typography color={'primary'} paddingTop={biggerThanSm?"200px":"75px"} paddingBottom={biggerThanSm?'60px':'10%'} variant={biggerThanSm?"h5":'h6'} component="h1"><strong>Ich coache Dich für Eure Hochzeit!</strong></Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <CoachingIntro />
                  </Grid>
                  <Grid item xs={6}>
                  <CoachingGoodToKnow />
                  </Grid>
                </Grid>
              </div>
            </div>
            <div className='slide'>
              <div className="fp-bg2 fp-auto-height-responsive">
                <GZ />
              </div>
            </div>
            </>
   )
}